import { configureStore } from '@reduxjs/toolkit';

import authReducer from './auth';
import consumptionsReducer from './consumptions';
import listenerReducer from './listeners';

const store = configureStore({
  reducer: { auth: authReducer, consumptions: consumptionsReducer, listeners: listenerReducer },
  devTools: process.env.NODE_ENV !== 'production',
});

export default store;

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
